import type { UniformAttribute } from '@use-gpu/core';
import type { ShaderSource } from '@use-gpu/shader';
import { useShaderRef } from '../../hooks/useShaderRef';
import { useSource, useNoSource } from '../../hooks/useSource';

const FACETS: UniformAttribute = { format: 'u32', name: 'getFacet' };

export type FacetSource = {
  facet?: number,
  facets?: ShaderSource,
};

export const useFacetShader = ({facet, facets}: FacetSource) => {
  const f = useShaderRef(facet, facets);
  return facets ?? facet ? useSource(FACETS, f) : (useNoSource(), undefined);
};
